import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { TicketProductType } from '../types';
import { ProductOptType } from '../types';

import { TicketProduct } from './ticketproduct';

const _schema = {
    "name": "TICKETOPTION",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "product", type: "objid" },
        { name: "prodopt", type: "objid", alias: "option" }
    ],
    relate: [
        { direction: ">", target: "TICKETPRODUCT", by: "product", name: "product", reason: "product", child: false, class: TicketProductType },
        { direction: ">", target: "PRODUCTOPT", by: "option", name: "option", reason: "option", child: false, class: ProductOptType }
    ]
} as const;

const _TicketOptionClass = CreateObject(_schema);
if (!_TicketOptionClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class TicketOption extends _TicketOptionClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): TicketOption {
        return this._Copy(store) as TicketOption;
    }

    /** Changelog rows lack `TICKETPRODUCT.options`; register on link (see TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || relation !== 'product' || !(related instanceof TicketProduct)){
            return;
        }

        if (related === this.product){
            related.AddOption(this);
        }
        else {
            related.DelOption(this);
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/
    
    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.product){
            if ((this.status == 'DE') && !this.Commited){
                this.product.DelOption(this);
            }
            else {
                this.product.DoRefresh(this.table);
            }    
        }
    } 
    
    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }     
}
